import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-productproperty',
  templateUrl: './productproperty.component.html',
  styleUrls: ['./productproperty.component.scss']
})
export class ProductpropertyComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
